export default "__VITE_ASSET__d52e310a__"